import { useEffect, useRef, useState } from 'react';
import Clipboard from 'clipboard';

export default (): [(element: Element | null) => void, boolean] => {
  const clipboard = useRef<Clipboard>();
  const [node, setNode] = useState<Element | null>(null);
  const [hasCopied, setHasCopied] = useState(false);

  useEffect(() => {
    if (node) {
      clipboard.current = new Clipboard(node);
      clipboard.current.on('success', () => {
        setHasCopied(true);
      });
    }

    return () => {
      if (clipboard.current) {
        clipboard.current.destroy();
      }
    };
  }, [node]);

  return [setNode, hasCopied];
};
